<template>
  <div class="row sep-top-xs sep-bottom-sm">
    <div class="col-md-12 checkout-main">
      <div class="panel panel-default panel-billing">
        <div
          class="panel-heading"
          style="
            border-left: solid 1px #ddd;
            border-right: solid 1px #ddd;
            border-top: solid 1px #ddd;
            border-bottom: solid 1px #ddd;
          "
        >
          <h5><strong>Billing Address</strong></h5>
        </div>
        <div class="alert alert-warning collapse"></div>

        <div id="billing-address" class="">
          <div class="panel-body">
            <div class="billing-address-controls">
              <div
                v-for="(billingAddress, index) in billingAddresses"
                :key="index"
                class="radio"
              >
                <label>
                  <input
                    v-model="billingAddressId"
                    type="radio"
                    :value="billingAddress.id"
                  />
                  <b>
                    {{ billingAddress.first_name }}
                    {{ billingAddress.last_name }}
                  </b>
                  {{ billingAddress.address }} {{ billingAddress.address2 }}
                  {{ billingAddress.city }}, {{ billingAddress.state }}
                  {{ billingAddress.zip }}, {{ billingAddress.country }}
                </label>
              </div>

              <div class="radio">
                <label>
                  <input v-model="billingAddressId" type="radio" :value="0" />
                  <b>Add New Address</b>
                </label>
              </div>
            </div>
            <address-form
              v-if="!billingAddressId"
              address-type="billing"
              :ship-to-billing-address="shipToBillingAddress"
              :region-label="regionLabel"
              :regions="regions"
              :countries="countries"
              :country="country"
              :save-address-route="saveAddressRoute"
              @new-address-saved="addAddressToList"
            >
            </address-form>
          </div>
        </div>
        <div
          class="panel-footer clearfix"
          style="
            border-left: solid 1px #ddd;
            border-right: solid 1px #ddd;
            border-bottom: solid 1px #ddd;
          "
        >
          <div class="ship_to_billing">
            <label>
              <input
                id="ship_to_billing"
                v-model="shipToBillingAddress"
                type="checkbox"
                value="1"
                name="ship_to_billing"
              />
              <b>Ship to / Installation Site is the same as Billing Address</b>
            </label>
          </div>
        </div>
      </div>

      <div
        v-if="!shipToBillingAddress"
        id="shipping_panel"
        class="panel panel-default panel-shipping"
      >
        <div
          class="panel-heading"
          style="
            border-left: solid 1px #ddd;
            border-right: solid 1px #ddd;
            border-bottom: solid 1px #ddd;
          "
        >
          Shipping / Installation Address
        </div>
        <div id="shipping-address" class="">
          <div class="panel-body">
            <div class="shipping-address-controls">
              <div
                v-for="(shippingAddress, index) in shippingAddresses"
                :key="index"
                class="radio"
              >
                <label>
                  <input
                    v-model="selectedShippingAddressId"
                    type="radio"
                    :value="shippingAddress.id"
                  />
                  <b>
                    {{ shippingAddress.first_name }}
                    {{ shippingAddress.last_name }}
                  </b>
                  {{ shippingAddress.address }}
                  {{ shippingAddress.address2 }} {{ shippingAddress.city }},
                  {{ shippingAddress.state }} {{ shippingAddress.zip }},
                  {{ shippingAddress.country }}
                </label>
              </div>
              <div class="radio">
                <label>
                  <input
                    v-model="selectedShippingAddressId"
                    type="radio"
                    :value="0"
                  />
                  <b>Add New Address</b>
                </label>
              </div>

              <address-form
                v-if="!shippingAddressId"
                address-type="shipping"
                :ship-to-billing-address="shipToBillingAddress"
                :region-label="regionLabel"
                :regions="regions"
                :countries="countries"
                :country="country"
                :save-address-route="saveAddressRoute"
                @new-address-saved="addAddressToList"
              >
              </address-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initialBillingAddresses: {
      type: Array,
      required: true,
    },
    initialShippingAddresses: {
      type: Array,
      required: true,
    },
    regionLabel: {
      type: String,
      required: true,
    },
    regions: {
      type: Object,
      required: true,
    },
    countries: {
      type: Object,
      required: true,
    },
    country: {
      type: String,
      required: true,
    },
    saveAddressRoute: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      billingAddresses: this.initialBillingAddresses,
      shippingAddresses: this.initialShippingAddresses,
      billingAddressId: null,
      shipToBillingAddress: true,
      selectedShippingAddressId: null,
    };
  },

  computed: {
    shippingAddressId() {
      if (this.shipToBillingAddress) {
        return this.billingAddressId;
      }
      return this.selectedShippingAddressId;
    },
  },

  watch: {
    billingAddressId(val) {
      this.$emit("address-changed", {
        addressType: "billing",
        addressId: val,
      });
    },

    shippingAddressId(val) {
      this.$emit("address-changed", {
        addressType: "shipping",
        addressId: val,
      });
    },
  },

  mounted() {
    this.billingAddressId = this.initialBillingAddresses.length
      ? this.initialBillingAddresses[0].id
      : 0;

    this.selectedShippingAddressId = this.initialShippingAddresses.length
      ? this.initialShippingAddresses[0].id
      : 0;
  },

  methods: {
    addAddressToList({ addressType, address: newAddress }) {
      if (newAddress.billing) {
        this.billingAddresses.push(newAddress);
      }

      if (newAddress.shipping) {
        this.shippingAddresses.push(newAddress);
      }

      if (addressType === "billing") {
        this.billingAddressId = newAddress.id;
      } else {
        this.selectedShippingAddressId = newAddress.id;
      }
    },
  },
};
</script>
